import React from "react";
import NavBar from "./NavBar";
import Home from "./Home";

const Landing = () => {
  return (
    <>
      <NavBar />
      <Home />
    </>
  );
};

export default Landing;
